<!-- 教师评价管理 -->
<template>
<div>
    <div class="index" v-if="!detail.show">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>

        <div>
			<el-form :inline="true" :model="queryParams" label-width="70px">
				<el-form-item label="">
					<el-date-picker v-model="queryParams.date" type="daterange" style="width: 240px;" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" >
					</el-date-picker>
				</el-form-item>
				<el-form-item label="">
                    <el-input v-model="queryParams.name" placeholder="请输入评价名称"></el-input>
                </el-form-item>
			</el-form>
            <el-form :inline="true" :model="queryParams" label-width="70px">
                <el-form-item label="评价周期">
                    <el-select v-model="queryParams.cycle" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in cycleList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="">
                    <el-select v-model="queryParams.zq" clearable placeholder="选择周期" class="label">
                        <el-option v-for="item in zqList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-select v-model="queryParams.state" clearable placeholder="评价状态" class="label">
                        <el-option v-for="item in stateList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
					<el-button type="primary" style="margin-left:20px" size="small" @click='add()'>新建评价</el-button>
                </el-form-item>
            </el-form>

            <!-- 校内教师 -->
            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="a" label="评价名称" align="center">
                    </el-table-column>
                    <el-table-column prop="b" label="评价周期" align="center">
                    </el-table-column>
                    <el-table-column prop="c" label="教师姓名" align="center">
                    </el-table-column>
                    <el-table-column prop="d" label="教师姓名" align="center">
                    </el-table-column>
                    <el-table-column prop="e" label="可评价时间" align="center">
                    </el-table-column>
					<el-table-column prop="f" label="评价完成情况" align="center">
                    </el-table-column>
                    <el-table-column prop="g" label="评价得分" align="center">
                    </el-table-column>
                    <el-table-column prop="h" label="评价维度" align="center">
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <Add :info.sync="detail.info" v-show="detail.show" @to-index="toIndex"></Add>
</div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
    components:{
        Add: ()=>import('./add.vue')
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				name:'',
				cycle: '',
				zq:'',
				state: '',
				class: '',
			},
			zqList:	[],	
			stateList: [
				{id:'1',label:'未完成'},
				{id:'2',label:'已完成'},
			],	
			cycleList: [
			{id:'xqp',label:'学期评'},
			{id:'yp',label:'月评'},
			{id:'zp',label:'周评'},
			],
			tableData: [
				// {a:'11月课后服务之星',b:"月评/11月",c:'吕娅伊',d:'本校',e:'2021-11-11 ~ 2021-11-30',f:'未完成',g:'90',h:'教师自评教师互评学生评家长评'},
				// {a:'学期课后服务优秀教师',b:"学期评/2021~2022学期上学期",c:'花璐菁',d:'本校',e:'2021-11-11 ~ 2021-11-30',f:'未完成',g:'90',h:'教师自评教师互评学生评家长评'},
				// {a:'10月课后服务之星',b:"月评/10月",c:'俞颖信',d:'本校',e:'2021-11-11 ~ 2021-11-30',f:'已完成',g:'90',h:'教师自评教师互评学生评家长评'},
				// {a:'09月课后服务之星',b:"月评/09月",c:'尹飘仪',d:'本校',e:'2021-11-11 ~ 2021-11-30',f:'已完成',g:'90',h:'教师自评教师互评学生评家长评'},
				// {a:'08月课后服务之星',b:"月评/08月",c:'项澜毓',d:'本校',e:'2021-11-11 ~ 2021-11-30',f:'已完成',g:'90',h:'教师自评教师互评学生评家长评'},
				// {a:'07月课后服务之星',b:"月评/07月",c:'崔荣孝',d:'本校',e:'2021-11-11 ~ 2021-11-30',f:'已完成',g:'90',h:'教师自评教师互评学生评家长评'},
			],
            detail:{
                info:{},
                show:false,
            },
			school_info:JSON.parse(sessionStorage.getItem('classList')),
			semesterArr:JSON.parse(sessionStorage.getItem('semesterList')),
		}
	},
	watch:{
		"queryParams.cycle": function (n, o) {
			this.queryParams.zq = "";
			if(n==='xqp'){
				this.zqList = [
				{id:'xqp1',label:'2021~2022年度下学期'},
				{id:'xqp2',label:'2021~2022年度上学期'},
				{id:'xqp3',label:'2020~2021年度下学期'},
				{id:'xqp4',label:'2020~2021年度上学期'},
				{id:'xqp5',label:'2019~2020年度下学期'},
				{id:'xqp6',label:'2019~2020年度上学期'},
				];
			}else if(n==='yp'){
				this.zqList = [
				{id:'yp1',label:'11月'},
				{id:'yp2',label:'10月'},
				{id:'yp3',label:'09月'},
				{id:'yp4',label:'08月'},
				{id:'yp5',label:'07月'},
				{id:'yp6',label:'06月'},
				];
			}else{
				this.zqList = [
				{id:'zp1',label:'第10周'},
				{id:'zp2',label:'第9周'},
				{id:'zp3',label:'第8周'},
				{id:'zp4',label:'第9周'},
				{id:'zp5',label:'第7周'},
				{id:'zp6',label:'第6周'},
				];
			}
		}
	},
	created() {
		// this.getDataList();
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				schoolYearSemester:this.queryParams.semester,
				campusId:this.queryParams.campus,
				classId:this.queryParams.class,
				gradeId:this.queryParams.grade,
				page:this.pageNum,
				limit:this.pageSize,
			}
			// let res = await api.studentClassStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toDetail(item){
			this.detail.info=item;
            this.detail.show=true;
        },
        toIndex(){
            this.detail.show=false;
        },
		add(){
			this.detail.show=true;
		},
	},
	mounted() {

	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
